import React, { useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";
import { useEffect } from "react";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LanguageIcon from "@mui/icons-material/Language";
import EditCustomer from "./EditCustomer";
import "./ViewSite.css";
import { toast, ToastContainer } from "react-toastify";
// import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../utils/apiservice";


const API_URL = process.env.REACT_APP_API_DJANGO_URL;
const ViewCustomer = () => {
  const [rows, setRows] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [siteToDelete, setSiteToDelete] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [deleteError, setDeleteError] = useState(false);


  // Add these inside your ViewSites component
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await apiService({
        url: "/api/get_customers/",
        method: "GET",
      });

      const formattedData = response.data.map((customer, index) => ({
        id: index + 1,
        customer_id: customer.tb_customer_id,
         customer_name: customer.customer_name,
        sites: customer.assigned_sites?.length
          ? customer.assigned_sites.map(site => site.name).join(", ")
          : "-",
        organization_email: customer.organization_email,   // ✅ FIX
        customer_address: customer.customer_address,       // ✅ FIX

        contact_person_name: customer.contact_person_name,
        contact_person_email: customer.contact_person_email,
        contact_person_designation: customer.contact_person_designation,
        contact_no: customer.contact_no,
      }));

      setRows(formattedData);
    } catch (error) {
      console.error("Error fetching customers:", error);
      toast.error("Failed to fetch customers");
    }
  };

  const handleEditClick = (site) => {
    setSelectedSite(site);
    setEditOpen(true);
  };

  const handleCloseEdit = () => setEditOpen(false);

  const handleSaveEdit = (updatedSite) => {
    setRows(rows.map(r => r.id === updatedSite.id ? updatedSite : r));
    setEditOpen(false);
  };


  const handleDeleteClick = (site) => {
    setSiteToDelete(site);
    setDeleteOpen(true);
  };


  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteMessage("");
    setDeleteError(false);
  };

  // const handleConfirmDelete = async () => {
  //   if (!siteToDelete) return;

  //   try {
  //     const token = localStorage.getItem("accessToken");
  //     const assetId = siteToDelete.asset_id;

  //     const response = await apiService({
  //       url: `/api/delete_site/${assetId}/`,
  //       method: "DELETE",
  //       data: {}, // force empty JSON body for backend
  //     });
  //     // ✅ Success
  //     const msg = response.data.message || "Site deleted successfully!";
  //     setDeleteMessage(msg);
  //     setDeleteError(false);

  //     toast.success(msg);

  //     // Remove row after short delay (optional UX)
  //     setTimeout(() => {
  //       setRows(rows.filter(r => r.id !== siteToDelete.id));
  //       setDeleteOpen(false);
  //       setDeleteMessage("");
  //     }, 1500);

  //   } catch (error) {
  //     console.error("Error deleting site:", error);

  //     const backendMessage =
  //       error.response?.data?.error ||
  //       error.response?.data?.message ||
  //       "Failed to delete site.";

  //     // ❌ Show inside modal
  //     setDeleteMessage(backendMessage);
  //     setDeleteError(true);

  //     // toast.error(backendMessage);
  //   }
  // };


  const handleConfirmDelete = async () => {
  if (!siteToDelete) return;

  try {
    const customerId = siteToDelete.customer_id; // tb_customer_id

    const response = await apiService({
      url: `/api/customer/delete/${customerId}/`,
      method: "DELETE",
    });

    const msg = response.data.message || "Customer deleted successfully!";
    setDeleteMessage(msg);
    setDeleteError(false);

    toast.success(msg);

    setTimeout(() => {
      setRows(rows.filter((r) => r.id !== siteToDelete.id));
      setDeleteOpen(false);
      setDeleteMessage("");
    }, 1500);

  } catch (error) {
    console.error("Error deleting customer:", error);

    const backendMessage =
      error.response?.data?.error ||
      error.response?.data?.warning ||
      error.response?.data?.message ||
      "Failed to delete customer.";

    setDeleteMessage(backendMessage);
    setDeleteError(true);
  }
};

  // const handleCancelDelete = () => {
  //   setDeleteOpen(false);
  // };

  return (
    <Box className="view-sites-container">

      {/* ✅ Toast Container */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* <TableContainer component={Paper} className="site-table"></TableContainer> */}
      <TableContainer component={Paper} className="site-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Customer Name</TableCell>
              <TableCell>Assigned Site</TableCell>
              <TableCell>Organization Email</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Contact person Name</TableCell>
              <TableCell>Contact person Email</TableCell>
              <TableCell>Contact person Designation</TableCell>
              <TableCell>Contact No</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  No Sites Are Available
                </TableCell>
              </TableRow>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {row.customer_name}
                      </Box>
                    </TableCell>
                    <TableCell>{row.sites}</TableCell>
                    <TableCell>{row.organization_email}</TableCell>
                    <TableCell>{row.customer_address}</TableCell>
                    <TableCell>{row.contact_person_name}</TableCell>
                    <TableCell>{row.contact_person_email}</TableCell>
                    <TableCell>{row.contact_person_designation}</TableCell>
                    <TableCell>{row.contact_no}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleEditClick(row)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton color="error" onClick={() => handleDeleteClick(row)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>


        
      </TableContainer>
      <div className="pagination-bar">
          <div className="rows-select">
            Rows per page:
            <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
            </select>
          </div>
          <div className="page-info">
            {rows.length > 0 ? page * rowsPerPage + 1 : 0}-
            {Math.min((page + 1) * rowsPerPage, rows.length)} of {rows.length}
          </div>
          <div className="page-arrows">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
            <button disabled={(page + 1) * rowsPerPage >= rows.length} onClick={() => setPage(page + 1)}>›</button>
          </div>
        </div>

      {selectedSite && (
        <EditCustomer
          open={editOpen}
          onClose={handleCloseEdit}
          customer={selectedSite}
          onSave={handleSaveEdit}
        />
      )}

      <Dialog
        open={deleteOpen}
        onClose={handleCancelDelete}
        className="delete-dialog"
      >
        <DialogTitle className="delete-dialog-title">
          Delete Customer
        </DialogTitle>

        <DialogContent>
          <DialogContentText className="delete-dialog-text">
            {!deleteMessage &&
              "Are you sure you want to delete this customer?"}
          </DialogContentText>

          {/* ✅ Backend Message */}
          {deleteMessage && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                borderRadius: 2,
                backgroundColor: deleteError ? "#fdecea" : "#e8f5e9",
                color: deleteError ? "#d32f2f" : "#2e7d32",
                fontWeight: 500,
              }}
            >
              {deleteMessage}
            </Box>
          )}
        </DialogContent>

        <DialogActions className="delete-dialog-actions">

          {/* ❌ If error → show only OK */}
          {deleteError && deleteMessage ? (
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          ) : deleteMessage && !deleteError ? (
            /* ✅ If success → show Done */
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="success"
            >
              Done
            </Button>
          ) : (
            /* 🟢 Default → show Cancel + Delete */
            <>
              <Button
                onClick={handleCancelDelete}
                variant="outlined"
                className="delete-cancel-btn"
              >
                Cancel
              </Button>

              <Button
                onClick={handleConfirmDelete}
                variant="contained"
                color="error"
              >
                Delete
              </Button>
            </>
          )}

        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ViewCustomer;